import React, { useState, useEffect } from 'react';

import { SectionLink } from './SideNavLinks';

import './sidenavlinkdiv.css'

const SideNavLinkDiv = ({ to, linkName, onClick, currentLocation, children }) => {

    const [isDropDownOpen, setDropDownOpen] = useState(false);

    const toggleOpen = () => {
        if (isDropDownOpen) return setDropDownOpen(false);
        if (!isDropDownOpen) return setDropDownOpen(true);
    }

    // NB! maybe change this one depending on the UX
    useEffect(() => {
        if(currentLocation && (currentLocation.indexOf('/', 1) !== -1 ? currentLocation.slice(0, currentLocation.indexOf('/', 1)) : currentLocation) === to) {
            setDropDownOpen(true)
        } else setDropDownOpen(false)

    }, [setDropDownOpen, currentLocation, to])

    return (
        <div className='sidenavlinkDiv__containerDiv'>
            <SectionLink
                to={to}
                onClick={onClick}
            >
                {linkName}
            </SectionLink>
            {
                children
                ? 
                    <>
                        <button
                            className={`sidenavlinkDiv__containerDiv__dropdownBtn ${isDropDownOpen ? 'sidenavlinkDiv__containerDiv__dropdownBtn--active' : '' }`}
                            onClick={() => toggleOpen()}
                        >
                        <svg className="bi bi-chevron-down" width="1.5em" height="1.5em" viewBox="0 0 20 20" fill="whitesmoke" xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="even" d="M3.646 6.646a.5.5 0 01.708 0L10 12.293l5.646-5.647a.5.5 0 01.708.708l-6 6a.5.5 0 01-.708 0l-6-6a.5.5 0 010-.708z" clipRule="evenodd"/>
                        </svg>                     
                        </button>
                        <div className={`sidenavlinkDiv__containerDiv__dropdownDiv ${isDropDownOpen ? 'sidenavlinkDiv__containerDiv__dropdownDiv--open' : 'sidenavlinkDiv__containerDiv__dropdownDiv--closed' }`}>
                            {children}
                        </div>
                    </>
                :
                null
            }

        </div>
    )
}


export default SideNavLinkDiv;